import { Monitoring } from './Monitoring'

/**
 * * Instance workspace: running teams, circles, and agents.
 * * Circle instances are not available yet.
 */
export function InstanceAgentsPage() {
  return <Monitoring section="agents" />
}

export function InstanceTeamsPage() {
  return <Monitoring section="teams" />
}

export function CircleInstancesPage() {
  return (
    <div className="page-content relative min-h-screen">
      <div className="background-image">
        <img src="/logo.jpg" alt="" />
      </div>
      <div className="content-wrapper">
        <h1 className="text-3xl font-extrabold mb-2 tracking-tight tab_title">Instances de cercles</h1>
        <div className="card mt-6">
          <div className="px-6 py-8">
            <p className="text-primary font-medium">Cette vue n'est pas encore disponible.</p>
            <p className="text-sm text-secondary mt-2">
              Les cercles se préparent dans Modèles. Le suivi de leurs instances viendra ensuite.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
